import { useContext } from "react";
import { LanguageContext } from "../LanguageProvider";
import { T } from "../T";
import { StyledProjects } from "./StyledProjects";

interface ProjectData {
  id: string;
  name: string;
  name_es: string;
  description: string;
  description_es: string;
  github: string;
  deploy: string;
  photo: string;
}

const projects: ProjectData[] = [
  {
    id: "placepack",
    name: "Placepack",
    name_es: "Placepack",
    description:
      "Bulk placeholder image generator for responsive UI testing. Built with React, Vite, TypeScript, and Tailwind CSS. Features a public documented API. Deployed on Vercel.",
    description_es:
      "Generador de imágenes placeholder para testing de UI responsiva. Construido con React, Vite, TypeScript y Tailwind CSS. Incluye una API pública documentada. Deployado en Vercel.",
    github: "",
    deploy: "https://placepack.top",
    photo: "https://placepack.top/og-image.png",
  },
];

export const Projects = () => {
  const { language } = useContext(LanguageContext);

  return (
    <StyledProjects id="projects">
      <h2>
        <T>projects</T>
      </h2>
      <div className="projectsContainer">
        <ul>
          {projects.map((e) => (
            <li key={e.id}>
              <div className="projectText">
                <h3>{language === "en" ? e.name : e.name_es || e.name}</h3>
                <div className="projectDescription">
                  {language === "en" ? e.description : e.description_es || e.description}
                </div>
                <div className="links">
                  {e.github && (
                    <div>
                      <a href={e.github} target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-github"></i>
                      </a>
                    </div>
                  )}
                  {e.deploy && (
                    <div>
                      <a href={e.deploy} target="_blank" rel="noopener noreferrer">
                        <i className="fas fa-external-link-alt"></i>
                      </a>
                    </div>
                  )}
                </div>
              </div>
              {e.photo && (
                <div className="projectPhoto">
                  <a href={e.deploy || e.github} target="_blank" rel="noopener noreferrer">
                    <img src={e.photo} alt={e.name} />
                  </a>
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </StyledProjects>
  );
};
